import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import global from './store/const'
// import moment from 'moment'
import vant from 'vant'
import 'vant/lib/index.css'
import VideoPlayer from 'vue-video-player'
import moment from 'moment'// 导入文件
import '@/assets/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 日历插件
import vueHashCalendar from 'vue-hash-calendar'
// 日历插件 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
// ActionSheet 动作面板
import { ActionSheet } from 'vant'
import { Notify } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
// 日历插件 注册组件库
Vue.use(vueHashCalendar)
Vue.use(Notify)
Vue.use(ElementUI)

Vue.prototype.$moment = moment// 赋值使用
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(vant)
Vue.config.productionTip = false
// ActionSheet 动作面板
Vue.use(ActionSheet)
Vue.prototype.GLOBAL = global

new Vue({
  router,
  store,
  moment,
  render: h => h(App)
}).$mount('#app')

